module.exports = __webpack_public_path__ + "img/tutorial_img_3_1.0f8e9f99.png";